'use client';

import { redirect } from 'next/navigation';

export default function ContactRedirect() {
  // Get the user's language from localStorage (default to 'ar')
  const language = localStorage.getItem('i18nextLng') || 'ar';

  // Redirect /contact → language-specific contact page
  redirect(`/${language}/contact`);
}
